<template>
  <div ref="wrapperRef" class="table-of-contents">
    <h2 class="t-h5">{{ t('article.contents') }}</h2>
    <ArticleTableOfContentsList
      :contents="contents as unknown as RecursiveContents[]"
    />
  </div>
</template>

<script setup lang="ts">
// Generated types are wrong
import type { Contents } from '@/service/__generated-api'
// Real type is:
import type { RecursiveContents } from '@/types/utils'

defineProps<{ contents: Contents[] }>()

const { t } = useI18n()
</script>

<style scoped lang="scss">
.table-of-contents {
  @include flex-col;
  gap: rem(15px);
  color: $layout-text-02;

  @include media-up(lg) {
    padding-top: rem(86px);
  }
}
</style>
